export enum Platform {
  FORTUNE = 'fortune',
  WORDPRESS = 'wordpress',
  FASTPASS = 'fastpass',
  SHOPEE = 'shopee',
}
